<template>
  <div class="checkSuccess">
    <innerWarp v-if="$store.state.isMobile">
      <slot v-if="type == 'check'">
        <!-- 江西书画院 -->
        <img src="../../assets/ticket/jxhy_logo.png" class="wbsImg jxhyImg" v-if="$route.query.museumCode == 218425">
        <img src="../../assets/wen_write.png" class="wbsImg" v-else>
        <div class="lineText">您已经核销成功!</div>
        <!-- <personalCard v-for="item in orders" :key="item.id">
          <div slot="right" class="rightContent">
            <div class="detail">
              <span class="title">预约时间</span>
              <span class="name">{{item.date}}（{{item.time}}）</span>
            </div>
            <div class="detail">
              <span class="title">参观人数</span>
              <span class="name">{{item.personNum}}</span>
            </div>
          </div>
        </personalCard> -->
        <div class="buttonConfirm" @click="toIndex">返回主页</div>
      </slot>
      <slot v-if="type == 'cancel'">
        <!-- 江西书画院 -->
        <img src="../../assets/ticket/jxhy_logo.png" class="wbsImg jxhyImg" v-if="$route.query.museumCode == 218425">
        <img src="../../assets/wen_write.png" v-else>
        <div class="lineText">预约取消成功!</div>
        <div class="buttonNormal" @click="toReservation">查看我的预约</div>
        <div class="buttonConfirm" @click="toIndex">返回主页</div>
      </slot>
      <slot v-if="type == 'submit'">
        <!-- 江西书画院 -->
        <img src="../../assets/ticket/jxhy_logo.png" class="wbsImg jxhyImg" v-if="$route.query.museumCode == 218425">
        <img src="../../assets/wen_write.png" v-else>
        <div class="lineText">信息提交成功!</div>
        <div class="buttonConfirm" @click="toIndex">返回主页</div>
      </slot>
    </innerWarp>
    <div v-else>
      <topBanner></topBanner>
      <div class="pcContent">
        <div class="pcItemCard">
          <div v-if="type == 'cancel'">
            <!-- 江西书画院 -->
            <img src="../../assets/ticket/jxhy_logo.png" class="jxhyImg" v-if="$route.query.museumCode == 218425">
            <img src="../../assets/ticket/wbs2.png" v-else>
            <div class="lineText">预约取消成功!</div>
          </div>
          <div v-if="type == 'submit'">
            <!-- 江西书画院 -->
            <img src="../../assets/ticket/jxhy_logo.png" class="jxhyImg" v-if="$route.query.museumCode == 218425">
            <img src="../../assets/wen_write.png" v-else>
            <div class="lineText">信息提交成功!</div>
            <div class="buttonConfirm" @click="toIndex">返回主页</div>
          </div>
        </div>
      </div>
      <div class="buttonsWarp">
        <div class="button3" @click="toReservation">查看我的预约</div>
        <div class="button4" @click="toIndex">返回主页</div>
      </div>
    </div>
  </div>
</template>

<script>
import innerWarp from '../../components/common/innerWarp.vue'
// import personalCard from '../../components/common/personalCard.vue'
import topBanner from '../../components/common/topBanner'
export default {
  data() {
    return {
      orders: [],
      type: '',
      query: {}
    };
  },

  components: {
    innerWarp, topBanner
  },

  methods: {
    toIndex() {
      this.$router.replace({path: '/ticket/home', query: this.query})
    },

    toReservation() {
      let url = !isNaN(Number(this.$route.query.museumCode)) ? '/ticket/ordersNew' : '/ticket/orders'
      this.$router.replace({path: url, query: this.query})
    }
  },

  mounted() {
    this.type = this.$route.query.type
    this.query.museumCode = this.$route.query.museumCode
    this.$route.query.orderType ? this.query.orderType = this.$route.query.orderType : ''
    this.$route.query.id ? (this.query.id = this.$route.query.id) : ''
  },

  computed: {
  
  }
}
</script>

<style lang="scss">
.checkSuccess{
  .wbsImg{
    width: 5rem;
    margin: 0.5rem 0;
  }
  .personalCard .left{
    width: 0.8rem;
  }
  .detail{
    width: 7.5rem;
  }
  .rightContent{
    width: 7.5rem;
  }
  .buttonNormal, .buttonConfirm{
    margin-top: 1rem;
  }
  .pcContent{
    .lineText{
      font-size: 0.25rem;
      margin-top: 0.2rem;
    }
    .pcItemCard{
      padding: 0.5rem 0;
      .jxhyImg{
        width: 250px;
        margin: 50px 0;
      }
    }
    .buttonConfirm{
      width: 150px;
      height: 50px;
      font-size: 24px;
      line-height: 50px;
    }
  }
  .button4{
    margin-left: 0.5rem;
  }
}
</style>
